import React from 'react';
import { Alert, Button, Col, Row, Spin, Typography } from 'antd';
import { PlusOutlined, LinkOutlined } from '@ant-design/icons';
import { SalesFragmentProps } from './interfaces';
import { useSalesController } from './sales.controller';
import { SalePropertyCardFragment } from 'fragments/sale-property-card/sale-property-card.fragment';
import { MarkForSaleFragment } from 'fragments/mark-for-sale/mark-for-sale.fragment';
import 'fragments/sales/sales.scss';

export const SalesFragment: React.FC<SalesFragmentProps> = (props) => {
    const { useController = useSalesController } = props;
    const controller = useController();

    return (
        <div className="sales-fragment">
            {/* MercadoLibre connection banner */}
            {!controller.mlConnected && (
                <Alert
                    className="ml-banner"
                    type="warning"
                    showIcon
                    message="Cuenta de MercadoLibre no conectada"
                    description="Conectá tu cuenta para poder publicar propiedades en MercadoLibre."
                    action={
                        <Button
                            size="small"
                            type="primary"
                            icon={<LinkOutlined />}
                            onClick={() => window.open(controller.mlAuthUrl, '_self')}
                        >
                            Conectar MercadoLibre
                        </Button>
                    }
                />
            )}

            {/* Header */}
            <Row className="sales-header" justify="space-between" align="middle">
                <Col>
                    <Typography.Title level={4} style={{ margin: 0 }}>
                        Propiedades en venta
                    </Typography.Title>
                </Col>
                <Col>
                    <Button type="primary" icon={<PlusOutlined />} onClick={controller.onMarkForSalePressed}>
                        Agregar propiedad
                    </Button>
                </Col>
            </Row>

            {/* List */}
            <Spin spinning={controller.isLoading}>
                <div className="sale-property-list">
                    {controller.saleProperties.map((sp) => (
                        <SalePropertyCardFragment
                            key={sp.id}
                            saleProperty={sp}
                            mlConnected={controller.mlConnected}
                            salesService={controller.salesService}
                            onRemoved={() => controller.onPropertyRemoved(sp.id)}
                            onUpdated={controller.onPropertyUpdated}
                            onListingUpdated={(updated) => controller.onListingUpdated(sp.id, updated)}
                        />
                    ))}
                    {!controller.isLoading && controller.saleProperties.length === 0 && (
                        <Typography.Text type="secondary">
                            No hay propiedades en venta. Agregá una para comenzar.
                        </Typography.Text>
                    )}
                </div>
            </Spin>

            {/* Mark for sale modal */}
            <MarkForSaleFragment
                isVisible={controller.isMarkModalVisible}
                salesService={controller.salesService}
                alreadyInSale={controller.saleProperties.map((sp) => sp.propertyId)}
                onMarked={controller.onPropertyMarked}
                onCancel={controller.onMarkForSaleCanceled}
            />
        </div>
    );
};
